import { createContext } from "@smartsheet/lodestar-utils";
import { ThemeMode } from "../util/themed";

export const LodestarCoreTheme = createContext<ThemeMode>("light", "LodestarCoreTheme");
